
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.386 13.623c0 4.55 3.72 8.253 8.289 8.253 4.57 0 8.289-3.703 8.289-8.253 0-4.55-3.72-8.253-8.289-8.253-4.57 0-8.289 3.703-8.289 8.253z"}})])
          )
        }
      }
    